import { Button } from 'antd';
import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';

import { ColourPicker, Select, Text } from '../../../WidgetConfiguratorComponents/FormGroups';
import { WarningBoxConfigBlockState } from '../types';

const COMPARATORS = ['is greater than', 'is less than', 'is greater than or equal to', 'is less than or equal to', 'is exactly equal to', 'is not equal to'];
const DELETE_TEXT = 'Delete';

interface WarningThresholdSettingsProps {
    setViewblockState: React.Dispatch<React.SetStateAction<WarningBoxConfigBlockState>>;
    viewblockState: WarningBoxConfigBlockState;
    warningId: string;
}
const WarningThresholdSettings = ({ viewblockState, setViewblockState, warningId }: WarningThresholdSettingsProps) => {
    if (!viewblockState.settings.thresholds) return <div />;

    return (
        <>
            {viewblockState.settings.thresholds
                .filter((threshold) => threshold.warningId === warningId)
                .map((threshold, thresholdIndex) => (
                    <React.Fragment key={`warning-threshold-settings-${threshold.id}`}>
                        <ColourPicker
                            value={threshold.color}
                            onChange={(color) => {
                                setViewblockState((prev) => {
                                    if (!prev.settings.thresholds) return prev;

                                    return {
                                        ...prev,
                                        settings: {
                                            ...prev.settings,
                                            thresholds: prev.settings.thresholds.map((t) => {
                                                if (threshold.id === t.id) return { ...t, color: color };
                                                return t;
                                            }),
                                        },
                                    };
                                });
                            }}
                        />
                        <Text
                            label='Warning Name'
                            maxLength={25}
                            value={threshold.name}
                            onChange={(name) => {
                                setViewblockState((prev) => {
                                    if (!prev.settings.thresholds) return prev;

                                    return {
                                        ...prev,
                                        settings: {
                                            ...prev.settings,
                                            thresholds: prev.settings.thresholds.map((t) => {
                                                if (threshold.id === t.id) return { ...t, name };
                                                return t;
                                            }),
                                        },
                                    };
                                });
                            }}
                        />
                        <Select
                            label='Logical operator'
                            value={threshold.comparator}
                            values={COMPARATORS}
                            onChange={(comparator: string) => {
                                setViewblockState((prev) => {
                                    if (!prev.settings.thresholds) return prev;

                                    return {
                                        ...prev,
                                        settings: {
                                            ...prev.settings,
                                            thresholds: prev.settings.thresholds.map((t) => {
                                                if (threshold.id === t.id) return { ...t, comparator };
                                                return t;
                                            }),
                                        },
                                    };
                                });
                            }}
                        />
                        <Text
                            label='Operator text'
                            value={threshold.label}
                            onChange={(label) => {
                                setViewblockState((prev) => {
                                    if (!prev.settings.thresholds) return prev;

                                    return {
                                        ...prev,
                                        settings: {
                                            ...prev.settings,
                                            thresholds: prev.settings.thresholds.map((t) => {
                                                if (threshold.id === t.id) return { ...t, label };
                                                return t;
                                            }),
                                        },
                                    };
                                });
                            }}
                        />
                        {/* Find a way to only allow input base on the value of data e.g. number or direction? */}
                        <Text
                            label='Limit'
                            value={threshold.value}
                            onChange={(value) => {
                                setViewblockState((prev) => {
                                    if (!prev.settings.thresholds) return prev;

                                    return {
                                        ...prev,
                                        settings: {
                                            ...prev.settings,
                                            thresholds: prev.settings.thresholds.map((t) => {
                                                if (threshold.id === t.id) return { ...t, value };
                                                return t;
                                            }),
                                        },
                                    };
                                });
                            }}
                        />

                        <Button
                            icon={<DeleteOutlined />}
                            danger
                            style={{ gridColumn: '3/6' }}
                            onClick={() => {
                                setViewblockState((prev) => {
                                    if (!prev.settings.thresholds) return prev;

                                    return {
                                        ...prev,
                                        settings: { ...prev.settings, thresholds: prev.settings.thresholds.filter((t) => t.id !== threshold.id) },
                                    };
                                });
                            }}
                        >
                            {DELETE_TEXT}&nbsp;<strong>{threshold.name}</strong>
                        </Button>
                        {viewblockState.settings.thresholds && thresholdIndex < viewblockState.settings.thresholds.length - 1 && (
                            <div style={{ gridColumn: '1/6', borderBottom: '1px solid white', height: 2 }}></div>
                        )}
                    </React.Fragment>
                ))}
        </>
    );
};

export default WarningThresholdSettings;
